import { useState, useEffect } from "react";
import Menu from "../../../components/layout/Menu";
import ModalConfirmLogout from "../../../components/modals/ModalConfirmLogout";
import useAuth from "../../../hooks/useAuth";
import { Braces, Building, FileCode, FileText, Home, Languages, Network, ShoppingBasket, ShoppingCart } from "lucide-react";

export default function Sidebar() {
    const { logout } = useAuth();
    const [heightPerColor, setHeightPerColor] = useState(0);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const colors = ["#2461DD", "#000000", "#A1A1A1", "#6D9CE2", "#2B36D9", "#A1A1A1"];

    const mainMenu = [
        {
            name: "Overview",
            icon: Home,
            path: "/admin/home",
            subItems: [],
        },

        { name: "Tenants" },
        {
            name: "Companies",
            icon: Building,
            path: "/admin/companies",
            subItems: [],
        },

        { name: "Blockchain" },
        {
            name: "Networks",
            icon: Network,
            path: "/admin/networks",
            subItems: [],
        },
        {
            name: "Smart Contracts",
            icon: FileText,
            path: "/admin/smart-contracts",
            subItems: [],
        },
        {
            name: "Source Code",
            icon: FileCode,
            path: "/admin/source-code",
            subItems: [],
        },
        {
            name: "ABIs",
            icon: Braces,
            path: "/admin/abis",
            subItems: [],
        },

        { name: "Payments" },
        {
            name: "Ramp",
            icon: ShoppingBasket,
            path: "/admin/ramp",
            subItems: [],
        },
        {
            name: "Ramp Sessions",
            icon: ShoppingCart,
            path: "/admin/ramp-sessions",
            subItems: [],
        },

        { name: "System" },
        {
            name: "Translations",
            icon: Languages,
            path: "/admin/translations",
            subItems: [],
        },
    ].filter(Boolean);

    useEffect(() => {
        const handleResize = () => {
            setHeightPerColor(window.innerHeight / colors.length);
        };

        handleResize();
        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, [colors.length]);

    const confirmLogout = () => {
        logout();
    };

    return (
        <div className="2xl:w-[340px] xl:w-[280px] w-[240px] bg-[#F2F2F2] 2xl:px-6 xl:px-5 px-4 2xl:py-6 py-4 relative flex flex-col h-screen">
            <div className="absolute top-0 left-0 h-full w-2">
                {colors.map((color, index) => (
                    <div key={index} style={{ height: heightPerColor, backgroundColor: color }} />
                ))}
            </div>

            <div className="flex items-center space-x-3 2xl:mb-8 mb-5">
                <div className="flex items-center justify-center">
                    <img src="/logo/engage.png" alt="Logo" className="2xl:w-full 2xl:h-full xl:w-[160px] w-[130px] object-contain" />
                </div>
            </div>

            <div className="flex-1 overflow-y-auto min-h-0">
                <Menu menu={mainMenu} />
            </div>

            <div className="mt-4 flex-shrink-0">
                <button
                    onClick={() => setIsModalOpen(true)}
                    className="flex items-center space-x-3 py-4 rounded-xl px-4 bg-gray-100 hover:bg-white w-full cursor-pointer"
                >
                    <img src="/icons/log-out.svg" alt="Log out" className="w-5 h-5" />
                    <span>Log out</span>
                </button>
            </div>

            <ModalConfirmLogout
                isOpen={isModalOpen}
                closeModal={() => setIsModalOpen(false)}
                onConfirm={confirmLogout}
            />
        </div>
    );
}
